import { style } from "@vanilla-extract/css";

import { text } from "~/styles/type.css";
import { vars } from "~/styles/tokens.css";

export const field = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  minWidth: 0,
});

export const labelRow = style([
  text.label,
  {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: vars.space.sm,
    color: vars.color.textDefault,
  },
]);

export const group = style({
  position: "relative",
  margin: 0,
  padding: 0,
  border: "none",
});

// A fieldset's legend is not one of its flex items, so the field's gap is
// restated below it.
export const legend = style({
  width: "100%",
  padding: 0,
  marginBottom: vars.space.xs,
});

// The status stays out of the legend, which names the group, so it is placed
// on the legend's line instead of flowing in it.
export const legendCaption = style({
  position: "absolute",
  top: 0,
  right: 0,
  lineHeight: `calc(${vars.fontSize.sm} * ${vars.lineHeight.tight})`,
});

/** The required mark. Exported because a caption that explains the mark has
 *  to show the same one. */
export const mark = style({
  color: vars.color.textMuted,
  fontWeight: vars.fontWeight.regular,
  marginLeft: vars.space["2xs"],
});

/** Quiet micro text: a status word, a caption, a secondary line. */
export const caption = style([
  text.micro,
  {
    color: vars.color.textMuted,
    fontWeight: vars.fontWeight.regular,
  },
]);

// Always rendered at one line's height, so showing or clearing a message
// moves no other control.
const line = style({
  display: "block",
  minHeight: `calc(${vars.fontSize.xs} * ${vars.lineHeight.normal})`,
  fontFamily: vars.font.body,
  fontSize: vars.fontSize.xs,
  lineHeight: vars.lineHeight.normal,
});

export const message = style([line, { color: vars.color.dangerOnSurface }]);

export const hint = style([line, { color: vars.color.textMuted }]);
